import './Tooltip.scss';

import { isString } from 'lodash-es';

import Button from '../Button/Button';

const Tooltip = ({ className, title, actions, tooltipMaxWidth }: $TSFixMe) => (
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any[]; popper: string; className... Remove this comment to see the full error message
  <div popper="true" className={`tooltip-component ${tooltipMaxWidth ? 'small' : ''} ${className || ''}`}>
    {isString(title) ? <p>{title}</p> : title}
    {actions && (
      <div className="inline-form-item align-end m-t-20">
        {actions.map((action: $TSFixMe, i: $TSFixMe) => (
          <Button
            key={i}
            className={action.noBorder ? 'no-border' : ''}
            default
            large
            content={action.label}
            onClick={action.action}
            isLink={action.isLink}
          />
        ))}
      </div>
    )}
  </div>
);

export default Tooltip;
